import { render, staticRenderFns } from "./share.vue?vue&type=template&id=5d9fa112&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&id=5d9fa112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9fa112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\openy-admin-all\\openy-wxms-web2026-09-01\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9fa112')) {
      api.createRecord('5d9fa112', component.options)
    } else {
      api.reload('5d9fa112', component.options)
    }
    module.hot.accept("./share.vue?vue&type=template&id=5d9fa112&scoped=true&", function () {
      api.rerender('5d9fa112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/share/share.vue"
export default component.exports